{
  "colorSwatchPicker": "Vzorkovníky farieb",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Vyberte položku",
  "tableResizer": "Nástroj na zmenu veľkosti"
}
